import { REGIONAL_OVERVIEW_INFO_MODAL_BACK_BUTTON } from '@features/regional-overview/domain/tests-id.constants';
import { Button, Modal } from 'antd';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalBackHeader } from '../modal-back-header';
import styles from './info-modal.module.css';

interface Props {
  onDismiss: () => void;
  visible: boolean;
  children: ReactNode;
  title: string;
  width?: string | number;
}

export const InfoModalContainer = ({ onDismiss, visible, children, title, width }: Props) => {
  const [t] = useTranslation();

  return (
    <Modal
      title={
        <ModalBackHeader
          title={t(title)}
          onBack={onDismiss}
          backAriaLabel={t('pages.regional_overview.info_modal.back_aria_label', 'Go back')}
          backButtonTestId={REGIONAL_OVERVIEW_INFO_MODAL_BACK_BUTTON}
        />
      }
      closable={{ 'aria-label': 'Custom Close Button' }}
      open={visible}
      onCancel={onDismiss}
      width={width}
      rootClassName={styles.responsiveModal}
      className={styles.fullscreenModal}
      classNames={{ container: styles.fullscreenContainer, body: styles.fullscreenBody }}
      destroyOnHidden
      footer={[
        <Button classNames={{ root: styles.gotItButton }} onClick={onDismiss} key={'Button'}>
          {t('pages.regional_overview.digital_traps.info_button.got_it')}
        </Button>
      ]}>
      <div className={styles.content}>{children}</div>
    </Modal>
  );
};
